@if (!pending()) {
  <button
    mat-flat-button
    color="accent"
    class="publish-button"
    [disabled]="disabled()"
    (click)="$event.stopPropagation(); onPublish()"
  >
    <mat-icon class="publish-button__icon">published_with_changes</mat-icon>
    <span>Veröffentlichen</span>
  </button>
} @else {
  <button mat-flat-button class="loading-button" color="accent" [disabled]="true" title="Wird veröffentlicht">
    <mat-progress-spinner class="loading-button__spinner" mode="indeterminate" diameter="20" />
  </button>
}
